import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseResource } from '../../core/abstractions/base.resource';
import { ActionResultModel } from '../../models/core/action-result.model';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { UrlParameterModel } from '../../models/core/url-parameter.model';
import { NotificationModel } from '../../models/notification.model';

@Injectable({
    providedIn: 'root'
})
export class NotificationsResource extends BaseResource {
    constructor() {
        super(new ResourceConfig({ baseController: 'notifications' }));
    }

    getAll(includeConfirmed?: boolean, numberOfDays?: number): Observable<ApiResponseModel<NotificationModel[]>> {
        const urlParams: UrlParameterModel[] = [];

        if (includeConfirmed) {
            urlParams.push(new UrlParameterModel({ key: 'includeConfirmed', value: includeConfirmed.toString() }));
        }

        if (!!numberOfDays) {
            urlParams.push(new UrlParameterModel({ key: 'numberOfDays', value: numberOfDays.toString() }));
        }

        return this._requestService.makeGet<ApiResponseModel<NotificationModel[]>>(
            this.getUrl(''),
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            ...urlParams
        );
    }

    markAsRead(id: string): Observable<ApiResponseModel<ActionResultModel>> {
        return this._requestService.makePost<any>(this.getUrl(`${id}/mark-as-read`));
    }
}
